import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  Snackbar,
  Alert,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { API_BASE_URL } from "../../../constant/constant";
import { decrypt } from "../../../components/cryptoUtil";
import EditDoctorProfile from "./editDoctorProfile"; // component for listing/editing doctors
import { Heading } from "../../componenet/heading";

function AddDoctor() {
  const tokenDataRaw = localStorage.getItem("tokenData");
  const decryptedData = tokenDataRaw ? JSON.parse(decrypt(tokenDataRaw)) : {};
  const token = localStorage.getItem("token");

  const [specializations, setSpecializations] = useState([]);
  const [loadingSpecializations, setLoadingSpecializations] = useState(true);

  const [doctor, setDoctor] = useState({
    hospital_code: decryptedData.softsubgroup || "",
    name: "",
    specialization: "",
    degree: "",
    fees: "",
    mobile: "",
    email: "",
    address: "",
    emergencyContact: "",
    registration: "",
    entryuser: decryptedData.userId || "",
    services: "",
  });

  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Personal Info", "Professional Info"];

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [refreshDoctors, setRefreshDoctors] = useState(false); // 👈 trigger refresh for doctor list

  const availableServices = ["IPD", "OPD", "Emergency"];

  useEffect(() => {
    let mounted = true;
    const fetchSpecializations = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hospital/specialization`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (mounted && Array.isArray(data)) setSpecializations(data);
      } catch (err) {
        console.error("Error fetching specializations:", err);
        setSnackbar({
          open: true,
          message: "Failed to load specializations",
          severity: "error",
        });
      } finally {
        setLoadingSpecializations(false);
      }
    };
    fetchSpecializations();
    return () => (mounted = false);
  }, [token]);

  // const handleDoctorChange = (e) =>
  //   setDoctor((prev) => ({ ...prev, [e.target.name]: e.target.value }));


function handleDoctorChange(e) {
  const { name, value } = e.target;

  if (name === "mobile") {
    // Only digits, max 10
    const onlyDigits = value.replace(/\D/g, "");
    if (onlyDigits.length <= 10) {
      setDoctor((prev) => ({ ...prev, mobile: onlyDigits }));
    }
    return;
  }



  if (name === "emergencyContact") {
  // Keep only digits
  let digits = value.replace(/\D/g, "");

  if (digits.length <= 10) {
    // Less than or equal to 10 digits → just keep them
    setDoctor((prev) => ({ ...prev, emergencyContact: digits }));
  } else {
    // More than 10 digits → insert comma after first 10
    const firstPart = digits.slice(0, 10);
    const secondPart = digits.slice(10, 20); // max 10 more
    const formatted = `${firstPart},${secondPart}`;
    setDoctor((prev) => ({ ...prev, emergencyContact: formatted }));
  }
  return;
}



  // Default case for other fields
  setDoctor((prev) => ({ ...prev, [name]: value }));
}





  const handleServicesChange = (e) => {
    const { target: { value } } = e;
    setDoctor((prev) => ({
      ...prev,
      services: Array.isArray(value) ? value.join(",") : value,
    }));
  };

  const isFormValid =
    doctor.hospital_code &&
    doctor.name &&
    doctor.specialization &&
    doctor.degree &&
    doctor.mobile &&
    doctor.email &&
    doctor.address &&
    doctor.emergencyContact &&
    doctor.registration &&
    doctor.entryuser;

  const handleNext = () => {
    if (activeStep === 0) {
      if (!doctor.name || !doctor.mobile || !doctor.registration || !doctor.email || !doctor.address || !doctor.emergencyContact) {
        setSnackbar({ open: true, message: "Please fill all required personal info fields", severity: "error" });
        return;
      }
    }

    if (activeStep === 1) {
      if (!doctor.specialization || !doctor.degree) {
        setSnackbar({ open: true, message: "Please fill specialization and degree", severity: "error" });
        return;
      }
    }

    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => setActiveStep((prev) => Math.max(0, prev - 1));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
      setSnackbar({ open: true, message: "Please complete all required fields", severity: "error" });
      return;
    }

    // try {
    //   const res = await fetch(`${API_BASE_URL}/api/hospital/adddoctors`, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    //     body: JSON.stringify(doctor),
    //   });
    //   const data = await res.json();
    //   //console.log(data);
    //   setSnackbar({ open: true, message: "Doctor added successfully", severity: "success" });

    //   // Reset form
    //   setDoctor({
    //     hospital_code: decryptedData.softsubgroup || "",
    //     name: "",
    //     specialization: "",
    //     degree: "",
    //     fees: "",
    //     mobile: "",
    //     email: "",
    //     address: "",
    //     emergencyContact: "",
    //     registration: "",
    //     entryuser: decryptedData.userId || "",
    //     services: "",
    //   });
    //   setActiveStep(0);

    //   // Trigger refresh for doctor list
    //   setRefreshDoctors((prev) => !prev);

    // } catch (err) {
    //   console.error("Error saving doctor:", err);
    //   setSnackbar({ open: true, message: "Failed to save doctor", severity: "error" });
    // }



    try {
  const res = await fetch(`${API_BASE_URL}/api/hospital/adddoctors`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json", 
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(doctor),
  });

  const data = await res.json();

  if (res.ok) {
    // ✅ success case
    setSnackbar({
      open: true,
      message: data.message || "Doctor added successfully",
      severity: "success",
    });
  } else {
    // ❌ failure case
    setSnackbar({
      open: true,
      message: data.message || "Failed to add doctor",
      severity: "error",
    });
  }
} catch (err) {
  // ❌ network/server error
  setSnackbar({
    open: true,
    message: err.message || "Something went wrong",
    severity: "error",
  });
}

  };

  return (
    <Card sx={{ maxWidth: 1200, mx: 'auto', mt: 4, boxShadow: 4 }}>
          <CardContent>
      
          <Heading headingtext="👨‍⚕️ Add New Doctor" />

<Card sx={{  mt: 4 }}>
        <CardContent>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form onSubmit={handleSubmit}>
            {activeStep === 0 && (
              <div>
                <div className="form-row">
                  <TextField fullWidth label=" 👨‍⚕️ Doctor Name" name="name" value={doctor.name} onChange={handleDoctorChange} margin="normal" required />
              
             <TextField
  fullWidth
  label="📞 Mobile Number"
  name="mobile"
  value={doctor.mobile}
  onChange={handleDoctorChange}
  margin="normal"
  required
  
  inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]{10}",
    maxLength: 10,
     placeholder: "1234567890 Max One Mobile Number"
  }}
/>
              
                              </div>

                <div className="form-row">
                  <TextField fullWidth label="🩺 Registration Number" name="registration" value={doctor.registration} onChange={handleDoctorChange} margin="normal" required />
                  <TextField fullWidth label="📩 Email" name="email" type="email" value={doctor.email} onChange={handleDoctorChange} margin="normal" required />
                </div>

                <TextField fullWidth label="📌 Address" name="address" value={doctor.address} onChange={handleDoctorChange} margin="normal" required multiline rows={2} />

               <TextField
  fullWidth
  label="☎️ Emergency Contact"
  name="emergencyContact"
  value={doctor.emergencyContact}
  onChange={handleDoctorChange}
  margin="normal"
  required
  inputProps={{
    maxLength: 21,
    placeholder: "1234567890,9450887365 Max two Mobile Number"
  }}
/>
              </div>
            )}

            {activeStep === 1 && (
              <div>
                <div className="form-row">
                  <TextField
                    select
                    fullWidth
                    label="🔖 Specialization"
                    name="specialization"
                    value={doctor.specialization}
                    onChange={handleDoctorChange}
                    margin="normal"
                    required
                    disabled={loadingSpecializations}
                  >
                    {specializations.map((spec) => (
                      <MenuItem key={spec.code || spec.id} value={spec.code || spec.name}>
                        {spec.name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField fullWidth label="🎀 Degree" name="degree" value={doctor.degree} onChange={handleDoctorChange} margin="normal" required />
                </div>

                <div className="form-row">
                  {/* <TextField
                    select
                    fullWidth
                    label="⏱ Services"
                    name="services"
                    value={doctor.services ? doctor.services.split(",") : []}
                    onChange={handleServicesChange}
                    margin="normal"
                    SelectProps={{ multiple: true, renderValue: (selected) => selected.join(", ") }}
                  >
                    {availableServices.map((service) => (
                      <MenuItem key={service} value={service}>
                        <Checkbox checked={doctor.services.split(",").includes(service)} />
                        <ListItemText primary={service} />
                      </MenuItem>
                    ))}
                  </TextField> */}

                  {/* <TextField fullWidth label="💰 Consultation Fees (₹)" 
                  name="fees" 
                  value={doctor.fees} onChange={handleDoctorChange}
                   type="number" 
                   margin="normal"
                    inputProps={{ max: 99999 }}
                   /> */}
               
              <TextField
  fullWidth
  label="💰 Consultation Fees (₹)"
  name="fees"
  value={doctor.fees}
  onChange={(e) => {
    let value = e.target.value;

    // Remove non-numeric characters
    value = value.replace(/\D/g, "");

    // Enforce max length 5
    if (value.length > 5) {
      value = value.slice(0, 5);
    }

    handleDoctorChange({ target: { name: "fees", value } });
  }}
  type="text"   // use text, not number, to make maxLength work manually
  margin="normal"
  inputProps={{
    maxLength: 5,
    inputMode: "numeric",
    pattern: "[0-9]*",
  }}
/>


               
                </div>
              </div>
            )}

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
              <Button disabled={activeStep === 0} onClick={handleBack}>Back</Button>
              {activeStep < steps.length - 1 ? (
                <Button variant="contained" onClick={handleNext}>Next</Button>
              ) : (
                <Button type="submit" variant="contained" color="primary" disabled={!isFormValid}>Save Doctor</Button>
              )}
            </div>
          </form>

          <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
            <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
          </Snackbar>
        </CardContent>

        <style>
          {`
            .form-row {
              display: flex;
              gap: 16px;
              flex-wrap: wrap;
            }
            .form-row > * {
              flex: 1;
              min-width: 250px;
            }
          `}
        </style>

        {/* Accordion for Doctor List */}
      <Accordion sx={{ mt: 3 }}>
        <AccordionSummary
  expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
  aria-controls="doctor-list-content"
  id="doctor-list-header"
  sx={{
        backgroundColor: "darkblue",
        color: "white",
        //p: 2,
        borderRadius: 2,
      }}
>
  <Typography variant="h6">👨‍⚕️ Explore Doctors</Typography>
</AccordionSummary>

        <AccordionDetails>
          <EditDoctorProfile refresh={refreshDoctors} />
        </AccordionDetails>
      </Accordion>

      </Card>

      
    </CardContent>
       </Card>
  );
}

export default AddDoctor;
